export const globals = {
  key: '28728f66-8698-4c66-bb2e-f1c0e0b7a753',
  api: 'https://my-runway.co.uk/api/', //'http://runway.yellowboxsoftware.cloud/api/', //'https://my-runway.co.uk/api/'
  cdn: 'https://my-runway.co.uk/uploads/', // 'http://runway.yellowboxsoftware.cloud/uploads/' //'https://my-runway.co.uk/uploads/',
  version: '1.0.2',
  server: 'Live' // Live // Dev
};